import * as types from '../constants';

export const initStaffListState = () => ({
  type: types.INIT_STAFF_LIST_STATE,
});

export const setStaffList = staffList => ({
  type: types.SET_STAFF_LIST,
  payload: staffList
});

export const setCurrentPageNumber = currentPageNumber => ({
  type: types.SET_STAFF_LIST_CURRENT_PAGE_NUMBER,
  payload: currentPageNumber
});

export const setPaginationItem = paginationItem => ({
  type: types.SET_STAFF_PAGINATION_ITEM,
  payload: paginationItem
});

export const setFilterItem = filterItem => ({
  type: types.SET_STAFF_FILTER_ITEM,
  payload: filterItem
});